
<div class="pt-1">
    <mat-icon class="example-icon text-black-500 cursor-pointer" aria-hidden="false"  svgIcon="mat_solid:visibility"></mat-icon>
</div>
